<template>
    <div
        id="be-visitatori-gallery"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />
            <main>
                <div class="barra-titolo-azioni bg-white border-bottom py-2">
                    <div class="container-fluid">
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-8">
                                <h1 class="mb-0">{{ $t('Immagini preferite') }}</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="d-flex justify-content-between flex-wrap">
                        <div>
                            {{ eventEmail }} ({{ eventTitle }})
                        </div>
                        <div>
                            <span class="text-blusbiadito mr-2">
                                <font-awesome-icon :icon="['fas', 'file-alt']" />
                                <a
                                    href="#"
                                    class="ml-1 text-blusbiadito"
                                    :title="$t('Scarica in formato testo')"
                                    @click.prevent="onDownloadTXT()"
                                >{{ $t('Scarica (txt)') }}</a>
                            </span>
                            &nbsp;|&nbsp;
                            <span class="text-blusbiadito ml-2">
                                <font-awesome-icon :icon="['fas', 'file-pdf']" />
                                <a
                                    href="#"
                                    class="ml-1 text-blusbiadito"
                                    :title="$t('Scarica in formato PDF')"
                                    @click.prevent="onDownloadPDF()"
                                >{{ $t('Scarica (pdf)') }}</a>
                            </span>
                        </div>
                    </div>

                    <b-table
                        class="elenco-visitatori tabella-responsive table mt-3 mb-0"
                        striped
                        id="viewers-table"
                        :per-page="pagination.perPage"
                        :current-page="pagination.currentPage"
                        :items="filteredViewers"
                        :fields="tableHead"
                        :tbody-tr-class="'visitatore mt-0'"
                    >
                        <template v-slot:cell(preview)="data">
                            <div class="img-wrapper text-center">
                                <a
                                    href='#'
                                    @click.prevent="onPreviewClicked(data.item.imageId)"
                                >
                                    <img :src="getUrl(data.item.imageId)" /></a>
                            </div>
                        </template>

                        <template v-slot:cell(title)="data">
                            <span
                                class="text-blusbiadito"
                                v-if="data.item.title"
                            >
                                {{data.item.title}}
                            </span>
                            <span v-else> - </span>
                        </template>

                        <template v-slot:cell(dateAdded)="data">
                            <span
                                class="text-blusbiadito"
                                v-if="data.item.dateAdded"
                            >
                                {{data.item.dateAdded | formatDate}}
                            </span>
                            <span v-else> - </span>
                        </template>
                    </b-table>

                    <nav
                        class="paginazione mt-3"
                        aria-label="Paginazione"
                    >
                        <b-pagination
                            v-model="pagination.currentPage"
                            :total-rows="paginationRows"
                            :per-page="pagination.perPage"
                            aria-controls="viewers-table"
                            align="right"
                            class="pagination justify-content-end mb-0"
                        />
                    </nav>
                </div>

                <b-modal
                    id="modal-preview"
                    title="Anteprima"
                    header-class="d-none"
                    footer-class="d-none"
                    centered
                    ok-only
                >
                    <div class="text-center">
                        <img
                            class="mw-100 mh-100"
                            :src="selectedImageUrl"
                        />
                    </div>
                </b-modal>

                <b-modal
                    id="exportExtension"
                    ref="exportExtension"
                    title="Estrazione report preferiti"
                    ok-only
                    ok-title="Continua"
                    @ok="onDownload"
                >
                    <div>
                        {{$t("Vuoi forzare, nel report, un'estensione diversa per i file immagine? (serve a semplificare eventuali filtri in caso di copia/incolla su Lightroom)") }}
                    </div>

                    <b-form-radio-group
                        id="radio-group-favorites"
                        v-model="forceExtension"
                        name="radio-group-favorites"
                        class="mt-3"
                    >
                        <b-form-radio
                            v-model="forceExtension"
                            name="force-extension-radio"
                            :value="true"
                        >{{ $t('Sì') }}</b-form-radio>
                        <b-form-radio
                            v-model="forceExtension"
                            name="force-extension-radio"
                            :value="false"
                        >{{ $t('No') }}</b-form-radio>
                    </b-form-radio-group>

                    <b-container
                        fluid
                        v-show="forceExtension"
                        class="mt-3"
                    >
                        <b-form-group
                            label="Inserisci estensione:"
                            label-cols-md="4"
                            label-size="md"
                            label-align-md="right"
                            class="mb-0"
                        >
                            <b-input-group
                                size="md"
                                class="w-25"
                            >
                                <b-form-input
                                    type="text"
                                    name="extension"
                                    id="extension"
                                    class="rounded-pill rilievo-ombra-interna"
                                    v-model="extension"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>

                    </b-container>
                </b-modal>
            </main>
            <backend-footer />
        </div>
    </div>
</template>

<script>
import BackendHeader from "../../../components/backend/Header";
import BackendFooter from "../../../components/backend/Footer";
export default {
    name: "BackendReportsVisitorsFavorites",

    components: { BackendFooter, BackendHeader },

    data() {
        return {
            eventTitle: null,
            eventEmail: null,
            selectedImageId: null,
            filteredViewers: [],
            pagination: {
                perPage: 10,
                currentPage: 1
            },
            tableHead: [
                {
                    key: "preview",
                    label: "Anteprima",
                    thClass: "px-1 text-center",
                    tdClass: "titolo align-middle px-1",
                    tdAttr: { "data-title": "Anteprima" }
                },
                {
                    key: "title",
                    label: "Nome",
                    thClass: "px-1",
                    tdClass: "titolo align-middle px-1",
                    tdAttr: { "data-title": "Nome" }
                },
                {
                    key: "dateAdded",
                    label: "Data selezione",
                    thClass: "px-1",
                    tdClass: "titolo align-middle px-1",
                    tdAttr: { "data-title": "Data selezione" }
                }
            ],

            favoritesExportFormat: "txt", // txt/pdf
            forceExtension: false,
            extension: ""
        };
    },

    mounted() {
        this.$api
            .backendGetFavorites(
                this.$route.params.eventId,
                this.$route.params.email
            )
            .then((response) => {
                console.debug("BACKEND_GET_FAVORITES", response);
                this.eventTitle = response.title;
                this.eventEmail = response.email;
                this.filteredViewers = response.favorites;
            })
            .catch((error) => {
                console.error("BACKEND_GET_FAVORITES", error);
            });
    },

    methods: {
        getUrl(imageId) {
            return this.$imagesService.getUrl(imageId, "web");
        },

        onPreviewClicked(imageId) {
            this.selectedImageId = imageId;
            this.$bvModal.show("modal-preview");
        },

        onDownload() {
            var extension = this.forceExtension ? this.extension : "";
            this.$api
                .backendDownloadFavorites(
                    this.$route.params.eventId,
                    this.$route.params.email,
                    this.favoritesExportFormat,
                    extension
                )
                .then((response) => {
                    console.log("BACKEND_DOWNLOAD_FAVORITES", response);

                    var data = response.data;
                    if (response.mimeType === "application/pdf") {
                        data = Buffer.from(data, "base64");
                    }

                    var filename =
                        response.mimeType === "application/pdf"
                            ? "RikordaEventi preferiti.pdf"
                            : "RikordaEventi preferiti.txt";

                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", filename);

                    document.body.appendChild(fileLink);
                    fileLink.click();

                    window.URL.revokeObjectURL(fileLink.href);
                })
                .catch((error) => {
                    console.error("BACKEND_DOWNLOAD_FAVORITES", error);
                });
        },

        openExtensionModal() {
            this.forceExtension = false;
            this.extension = "";
            this.$bvModal.show(this.$refs.exportExtension.id);
        },

        onDownloadTXT() {
            this.favoritesExportFormat = "txt";
            this.openExtensionModal();
        },

        onDownloadPDF() {
            this.favoritesExportFormat = "pdf";
            this.openExtensionModal();
        }
    },

    computed: {
        paginationRows() {
            return this.filteredViewers.length;
        },

        selectedImageUrl() {
            return this.getUrl(this.selectedImageId);
        }
    }
};
</script>

<style scoped>
.img-wrapper img {
    max-width: 15vw;
    max-height: 15vh;
}
</style>
